const map = {
	"./10_rental.jpg": 9315,
	"./11_evnollment.jpg": 4130,
	"./12_course.jpg": 8516,
	"./1_about.jpg": 4028,
	"./2_event.jpg": 6012,
	"./3_ablum.jpg": 9460,
	"./4_member.jpg": 8146,
	"./5_essay.jpg": 8682,
	"./6_faq.jpg": 4680,
	"./7_story.jpg": 1814,
	"./8_contact.jpg": 6502,
	"./Chairman.png": 1686,
	"./DirectorPersonnel1.png": 7258,
	"./DirectorPersonnel2.png": 7425,
	"./DirectorPersonnel3.png": 3208,
	"./DirectorPersonnel4.png": 8375,
	"./DirectorPersonnel5.png": 6414,
	"./DirectorPersonnel6.jpg": 3589,
	"./NGHQRCode.png": 5886,
	"./SecretaryGeneral.png": 8333,
	"./Supervisor1.png": 9472,
	"./Supervisor2.png": 1227,
	"./adminPanelSettings.svg": 7707,
	"./assignment.svg": 4802,
	"./backgroundImage.jpg": 9380,
	"./bank.svg": 3687,
	"./creditCard.svg": 636,
	"./essayImage.jpg": 1119,
	"./eventImage.jpg": 5384,
	"./eventImage1.jpg": 1567,
	"./eventImage10.jpg": 8703,
	"./eventImage11.jpg": 6322,
	"./eventImage12.jpg": 6221,
	"./eventImage13.jpg": 5088,
	"./eventImage14.jpg": 1571,
	"./eventImage15.jpg": 1462,
	"./eventImage16.jpg": 1809,
	"./eventImage17.jpg": 3764,
	"./eventImage18.jpg": 8183,
	"./eventImage19.jpg": 4346,
	"./eventImage2.jpg": 7232,
	"./eventImage20.jpg": 3034,
	"./eventImage3.jpg": 8157,
	"./eventImage4.jpg": 6710,
	"./eventImage5.jpg": 5235,
	"./eventImage6.jpg": 756,
	"./eventImage7.jpg": 4481,
	"./eventImage8.jpg": 2426,
	"./eventImage9.jpg": 8231,
	"./facebook.svg": 9321,
	"./feedback.svg": 8276,
	"./homeBanner.jpg": 2812,
	"./line.svg": 2615,
	"./location.svg": 1560,
	"./logo.svg": 576,
	"./mail.svg": 632,
	"./mainImage1.jpg": 4124,
	"./mainImage2.jpg": 6107,
	"./mainImage3.jpg": 8062,
	"./mainImage4.jpg": 533,
	"./organization.png": 7742,
	"./phone.svg": 9671,
	"./question.svg": 457,
	"./storyImage.jpg": 309,
	"./testVideo.mp4": 9729
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;